const pickThemeValue = (...values) => {
    for (const value of values) {
        if (
            value !== undefined &&
            value !== null &&
            value !== "" &&
            value !== "null"
        ) {
            return value;
        }
    }
    return undefined;
};

const buildThemeMode = (payload) => {
    const headerTheme = payload?.theme_mode_details || {};
    const siteTheme = payload?.siteThemeSetting || {};
    const currentMode = 'light';
    const useDarkTheme = false;

    if (siteTheme && Object.keys(siteTheme).length > 0) {
        return {
            body: useDarkTheme
                ? pickThemeValue(siteTheme.admin_dark_bg_color, siteTheme.dark_bg_color, headerTheme.bg_color, '#1f222a')
                : pickThemeValue(siteTheme.admin_light_bg_color, siteTheme.light_bg_color, headerTheme.bg_color, '#ffffff'),
            text: useDarkTheme
                ? pickThemeValue(siteTheme.admin_dark_text_color, siteTheme.dark_text_color, headerTheme.text_color, '#fdfcfc')
                : pickThemeValue(siteTheme.admin_light_text_color, siteTheme.light_text_color, headerTheme.text_color, '#1d1f21'),
            button: useDarkTheme
                ? pickThemeValue(
                    siteTheme.admin_dark_button_bg_color,
                    siteTheme.button_bg_color,
                    siteTheme.dark_button_bg_color,
                    headerTheme.button_color,
                    '#4db8ff'
                )
                : pickThemeValue(
                    siteTheme.admin_light_button_bg_color,
                    siteTheme.button_bg_color,
                    siteTheme.light_button_bg_color,
                    headerTheme.button_color,
                    '#139DF2'
                ),
            buttonText: useDarkTheme
                ? pickThemeValue(
                    siteTheme.admin_dark_button_text_color,
                    headerTheme.button_text_color,
                    siteTheme.dark_button_text_color,
                    '#ffffff'
                )
                : pickThemeValue(
                    siteTheme.admin_light_button_text_color,
                    headerTheme.button_text_color,
                    siteTheme.light_button_text_color,
                    '#ffffff'
                ),
            secondarycolor: useDarkTheme
                ? pickThemeValue(
                    siteTheme.admin_dark_bg_secondary_color,
                    siteTheme.dark_bg_secondary_color,
                    headerTheme.bg_secondary_color,
                    '#2d3038'
                )
                : pickThemeValue(
                    siteTheme.admin_light_bg_secondary_color,
                    siteTheme.light_bg_secondary_color,
                    headerTheme.bg_secondary_color,
                    '#f5f7fc'
                ),
            secondarybody: useDarkTheme
                ? pickThemeValue(
                    siteTheme.admin_dark_bg_secondary_color,
                    siteTheme.dark_bg_secondary_color,
                    headerTheme.bg_secondary_color,
                    '#2d3038'
                )
                : pickThemeValue(
                    siteTheme.admin_light_bg_secondary_color,
                    siteTheme.light_bg_secondary_color,
                    headerTheme.bg_secondary_color,
                    '#f5f7fc'
                ),
            currentMode,
            logoUrl: headerTheme.logo_url,
            hoverCard: headerTheme.enable_slider
        };
    }

    return {
        body: headerTheme.bg_color || '#ffffff',
        text: headerTheme.text_color || '#1d1f21',
        button: headerTheme.button_color || '#139DF2',
        buttonText: headerTheme.button_text_color || '#ffffff',
        secondarycolor: headerTheme.bg_secondary_color || '#f5f7fc',
        secondarybody: headerTheme.bg_secondary_color || '#f5f7fc',
        currentMode,
        logoUrl: headerTheme.logo_url,
        hoverCard: headerTheme.enable_slider
    };
};

const headerIndexReducer = (state = {
    headerMenus: null,
    themeMode: {
        body: '#ffffff',
        secondarycolor: '#f5f7fc',
        secondarybody: '#f5f7fc',
        text: '#1d1f21',
        button: '#139DF2',
        buttonText: '#ffffff',
        currentMode: 'light',
        // logoUrl: 'https://www.classtools.net/profiles/demo-logo.png'
    },
    currentTheme: 1,
    headerSetting: null, error: null, isLoading: true
}, action) => {
    // console.log("action?.payload",action?.payload); 
    switch (action.type) {
        case "GET_HEADERINDEX_ACTION":
            return {
                ...state,
                headerMenus: action.payload.menu,
                headerindexall: action.payload,
                userDetails: action.payload.user_details,
                currentTheme: action?.payload?.current_theme?.slice(-1),
                themeMode: buildThemeMode(action.payload),
                headerSetting: action?.payload?.settings,
                isLoading: false
            };
        case "GET_HEADERINDEX_ACTION_FAILED":
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };

        default:
            return state;
    }
}



export { headerIndexReducer };
